<template>
  <div>
    <el-row style="flex-wrap:wrap;" justify="center" align="middle"
    >
      <div style="word-wrap: break-word" :id="'eqContentId_'+nowCheckIndex"
        v-html="questionInfo.eqOtherInfo_16[nowCheckIndex].eqContent"
      ></div>
    </el-row>
    <div class="switchQuestion">
      <div class="questionBox" :class="index==nowCheckIndex?'activeQuestion':''" v-for="(one,index) in questionInfo.eqOtherInfo_16" :key="'eqContent_'+index" @click="changeIndex(index)" >
        {{one.eqName}}
      </div>
    </div>
    <el-row style="flex-wrap:wrap;" justify="center" align="middle">
      <el-checkbox-group  v-model="value.eqAnswer[nowCheckIndex]"
                          :disabled="(showType == 3)?false:true"

      >
        <el-col v-for="(eqOptionOne,eqOptionIndex) in questionInfo.eqOption" :key="'eqOption_'+nowCheckIndex+'_'+eqOptionIndex"
                :xs="24" :sm="24" :md="24" :lg="24" :xl="24" >
          <el-checkbox class="el_checkbox" :label="eqOptionIndex+''">
            <span>{{zmArr[eqOptionIndex]}}:</span> <span style="" v-html="eqOptionOne"></span>
            </el-checkbox>
            <!-- {{zmArr[eqOptionIndex]}}: {{eqOptionOne}} -->
        </el-col>
      </el-checkbox-group>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'DoQuestion16',
  props: {
    questionInfo:{
      type:Object,
      default:{}
    },
    value:{
      type:Object,
      default:{}
    },
    showType:{
      type:Number,
      default:0
    }
  },
  data() {
    return {
      nowCheckIndex:0,
      zmArr:["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"]
    };
  },
  created() {
    
  },
  mounted() {
    
  },
  components: {
  },
  computed: {
  },
  methods: {
    changeIndex(index){
      this.nowCheckIndex = index;
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .switchQuestion{display: flex;justify-content: flex-start;  }
  .switchQuestion div:nth-child(2){border-left: none;border-right: none}
  .switchQuestion div:first-child{border-bottom-left-radius: 5px;border-top-left-radius: 5px}
  .switchQuestion div:last-child{border-bottom-right-radius: 5px;border-top-right-radius: 5px}
  .questionBox{border: 1px solid #ddd;padding: 30px 15px;cursor: pointer}
  .activeQuestion{background-color: #7299FE;color: #fff}
</style>
